
import React, { useState, useRef, useEffect } from 'react';
import { Button, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

function Controls({
    books,
    selectedBook,
    handleBookChange,
    chapters,
    selectedChapter,
    handleChapterChange,
    handlePreviousChapter,
    handleNextChapter,
    bookId,
    searchQuery,
    handleSearchChange,
    handleSearchSubmit,
    showSearch = false
}) {
    const [searchVisible, setSearchVisible] = useState(false);
    const inputRef = useRef(null);

    const toggleSearch = (e) => {
        e.preventDefault();
        setSearchVisible(!searchVisible);
    };

    useEffect(() => {
        if (searchVisible) {
            inputRef.current.focus();
        }
    }, [searchVisible]);

    return (
        <div className="controls-container">
            <select id="book-select" onChange={handleBookChange} value={bookId || ''} style={{ minWidth: 150, marginRight: '1rem', fontSize: '1.3rem' }}>
                {books.map(book => (
                    <option key={book.book_number} value={book.book_number}>{book.long_name}</option>
                ))}
            </select>
            <div className="chapter-nav">
                <Button onClick={handlePreviousChapter} disabled={!selectedBook || selectedChapter <= 1}>&lt;</Button>
                <select id="chapter-select" onChange={handleChapterChange} value={selectedChapter} disabled={!selectedBook} style={{ minWidth: 150, fontSize: '1.3rem' }}>
                    {chapters.map(chapter => (
                        <option key={chapter} value={chapter}>{chapter}</option>
                    ))}
                </select>
                <Button onClick={handleNextChapter} disabled={!selectedBook || selectedChapter >= chapters.length}>&gt;</Button>
            </div>
            {showSearch && (
                <div className="search-controls">
                    <form onSubmit={handleSearchSubmit} className={`search-form ${searchVisible ? 'expanded' : ''}`}>
                        {!searchVisible && <IconButton onClick={toggleSearch}><SearchIcon /></IconButton>}
                        <input
                            ref={inputRef}
                            type="text"
                            className={`form-control ${searchVisible ? '' : 'd-none'}`}
                            placeholder="Поиск..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{ fontSize: '1.3rem', height: '1.3rem' }}
                        />
                    </form>
                </div>
            )}
        </div>
    );
}

export default Controls;
